import { Branch } from "interfaces/Branch";
import { create } from "zustand";

interface BranchStoreProps {
  branch: Branch | null;
  setBranch: (branch: Branch | null) => void;
  isEdit: boolean;
  setIsEdit: (state: boolean) => void;
  isOpenModal: boolean;
  setIsOpenModal: (state: boolean) => void;
  handleOpenModal: () => void;
  handleCloseModal: () => void;
  clearAll: () => void;
}

export const useBranchStore = create<BranchStoreProps>((set, get) => ({
  branch: null,
  setBranch: (branch) => {
    set({ branch: branch });
  },
  isEdit: false,
  setIsEdit: (state) => {
    set({ isEdit: state });
  },
  isOpenModal: false,
  setIsOpenModal: (state) => {
    set({ isOpenModal: state });
  },
  handleOpenModal: () => {
    set({ isOpenModal: true });
  },
  handleCloseModal: () => {
    set({ isOpenModal: false });
  },
  clearAll: () => {
    set({
      branch: null,
      isEdit: false,
      isOpenModal: false,
    });
  },  
}));
